import { BarChartMarker } from "@evergis/charts";

import { FilterItem } from "../types";

export const getChartMarkers = (items: FilterItem[], markers: BarChartMarker[]): BarChartMarker[] => {
  return (
    markers?.map(marker => ({
      ...marker,
      value: items?.findIndex(({ name }) => name.toString() === marker.value?.toString()),
    })) || []
  );
};
